import type { CheckoutPayload } from '../../Checkout.utils';
import { type SubmitOrderMutationResponse } from './common';
import { useSubmitOrderUsingBillingAccount } from './useSubmitOrderUsingBillingAccount';
import { useSubmitOrderUsingPaymentMethodCard } from './useSubmitOrderUsingPaymentMethodCard';

/**
 * Selects the correct mutation flow depending on {paymentMethodType}.
 */
export function useSubmitOrderMutation(
  payload: CheckoutPayload,
): SubmitOrderMutationResponse {
  const usingBillingAccount = useSubmitOrderUsingBillingAccount();
  const usingPaymentMethodCard = useSubmitOrderUsingPaymentMethodCard();

  if (payload.paymentMethodType === 'PaymentMethodCard') {
    return usingPaymentMethodCard;
  }

  return usingBillingAccount;
}
